import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { MaterialDto } from './material.dto';
import { MaterialCreatableInterface } from '../interfaces/material-creatable.interface';

export class MaterialCreateDto
  extends IntersectionType(
    PickType(MaterialDto, ['name', 'unit', 'amount', 'boardPurchaseId']),
    PartialType(PickType(MaterialDto, ['description'])),
  )
  implements MaterialCreatableInterface {}
